import { Suspense, useEffect, useContext, useState } from 'react'
import { useRoutes, useNavigate, useLocation } from 'react-router-dom'
import CmsRouter from './routers/cms'
import './App.less'
import '@/assets/css/global.less'
import '@/assets/css/iconfont/iconfont.css'
import Loading from '@/assets/images/loading2.gif'
import { ConfigProvider } from 'antd'
import locals, { andtdLoacal, TLangKey } from './locale'
import { TabContext } from './contexts/TabContext'
import classNames from 'classnames'
import useRefreshTime from './contexts/intl'
import intl from 'react-intl-universal'
// import zh_CN from '@/locale/translation/zh-CN'
// import en_US from '@/locale/translation/en-US'
import zh_CN from '@/locale/translation/zh-CH'
import en_US from '@/locale/translation/en-GB'
import { useAtom } from 'jotai'
import { langAtom } from './store/lang.store'
import Cookies from 'js-cookie'
import { getDataFormSeamCookie, getFormLocalstorage, removeToken } from '@/utils/utils'
import { getcliantId, setUserInfofn } from '@/common/components/authloading'
import queryString from 'query-string'
import { modules } from '@/common/components/Header'
import { getMenuData } from './components/common/MenusWrapper'
import { IEditorConfig, DomEditor, i18nChangeLanguage, Boot } from '@wangeditor/editor'

import LatterSpaceing from "@/components/common/Wangeditor/latterSpace"
import renderStyle from '@/components/common/Wangeditor/addstyle'
import styleToHtml from '@/components/common/Wangeditor/styletohtml'
import parseStyleHtml from '@/components/common/Wangeditor/parsetStyleToEditor'
import { ViewSourceMenu } from '@/components/common/Wangeditor/wangeditor-view-source-menu'
import Margin from './components/common/Wangeditor/margin'
ConfigProvider.config({
  theme: { primaryColor: getDataFormSeamCookie('theme') || '#ee4d2d', },
});



Boot.registerStyleToHtml(styleToHtml)
Boot.registerRenderStyle(renderStyle)
Boot.registerParseStyleHtml(parseStyleHtml)
Boot.registerMenu({
  key: 'coustmomLatterSpaceing',
  factory() {
    return new LatterSpaceing()
  }
})
Boot.registerMenu({
  key: 'viewHtml',
  factory() {
    return new ViewSourceMenu()
  }
})
Boot.registerMenu({
  key: 'margin',
  factory() {
    return new Margin()
  }
})
i18nChangeLanguage('en')

function App() {
  const [loading, setLoading] = useState<boolean>(true)
  const [refreshTime, setRefreshTime] = useRefreshTime()
  const { activeTab } = useContext(TabContext)
  const [lang, setLang] = useAtom(langAtom)
  let router = CmsRouter
  let appClassName = 'cms-app-container'
  // activeTab == 0 ? 'sales-app-container' : activeTab == 1 ? 'cms-app-container' : 'setting-app-container'
  let Routers = useRoutes(router)
  const navigate = useNavigate()
  const location = useLocation()
  // useEffect(() => {
  //   console.log(process.env.REACT_APP_BESE_URL, 'console.log(process.env.REACT_APP_BASE_URL)')
  //   if (location.pathname === '/') {
  //     if (userInfo?.id) {
  //       navigate('/shipment-list')
  //     } else {
  //       navigate('/login')
  //     }
  //   }
  // }, [location.pathname])

  const checkHasPermistion = async () => {
    const query = queryString.parse(window.location.search)
    const token = query.token ?? ''
    const init_page = query.init_page ?? ''
    if (query.rc_access_ticket) {
      Cookies.set('rc_access_ticket', query.rc_access_ticket, { expires: 1000 * 60 * 60 * 24, path: '/' })
    }

    if (!Cookies.get('rc_access_token') && !['/login', '/register', '/authloading'].includes(location.pathname)) {
      if (!Cookies.get('rc_access_ticket')) {
        removeToken()
        if (process.env.NODE_ENV == 'development') {
          setLoading(false)
          navigate('/login')
        } else {
          window.location.href = `${process.env.REACT_APP_AUTHPATH}/oauth/authorized?clientId=${getcliantId()}&loginUrl=${process.env.REACT_APP_AUTHLOGIN}&state=zero`
        }
      }
    } else {
      if (!token && !init_page && process.env.NODE_ENV !== 'development') { //排除九宫格切换，初始化登录。每次刷新都要校验是否已经退出登录
        await setUserInfofn(Cookies.get('rc_access_token'), getcliantId())
      }
      setLoading(false)
    }
  }
  const routerHistory = useLocation()
  const changeSeo = (routerHistory: Location) => {
    if (routerHistory.pathname == '/authloading' || routerHistory.pathname == '/store/select') return true
    const activeTab = modules.find(items => items.url.indexOf(window.location.host) > -1)?.value ?? 0
    const menuData = getMenuData(activeTab)
    const title = document.querySelector('title')
    const findActiveName = menuData.find(i => i.activekey == routerHistory.pathname.split('/')[1])
    const menuName = routerHistory.pathname !== '/' ?
      intl.get((findActiveName?.langKey) ?? 'loading') == '' ? findActiveName?.name : intl.get(findActiveName?.langKey) :
      intl.get(menuData[0].langKey ?? 'loading')
    try {
      title.innerHTML = `${menuName.charAt(0).toUpperCase() + menuName.slice(1)} | ${getDataFormSeamCookie('rc_sc_login_module')} | DTC Platform`
    } catch (error) {
      title.innerHTML = `DTC Platform`
    }
  }
  useEffect(() => {
    checkHasPermistion()
    changeSeo(routerHistory)
  }, [routerHistory])
  useEffect(() => {
    setLang(getDataFormSeamCookie('locale') ?? "en_US")
  }, [])
  useEffect(() => { initIntl(setRefreshTime) }, [lang])


  const initIntl = async (refreshPage: any) => {
    let languageData = {
      loca: {
        zh_CN: zh_CN,
        en_US: en_US
      }
    }
    intl.init({
      currentLocale: lang,
      locales: languageData?.loca,
      fallbackLocale: 'en_US'
    }).then(() => {
      refreshPage(Math.random() * 10000)
    }).catch(error => {
      console.log(error)
    });
  }

  if (loading) {
    return (
      <div className='w-full h-screen flex justify-center items-center'>
        <img className='mb-15' alt='' style={{ width: '100px' }} src={Loading} />
      </div>
    )
  }

  return (
    <div className='App text-center languageVersion4' key={refreshTime}>
      <ConfigProvider locale={andtdLoacal?.antd?.[getDataFormSeamCookie('locale') ?? 'en_US']}>
        <Suspense
          fallback={
            <div className='w-full h-screen flex justify-center items-center'>
              <img className='mb-15' alt='' style={{ width: '100px' }} src={Loading} />
            </div>
          }
        >
          <div className={classNames('text-left', appClassName)}>{Routers}</div>
        </Suspense>
      </ConfigProvider>
    </div>
  )
}

export default App
